class GatewaysOrderDatatable {
    constructor() {
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.datatable = this.init('#gateways-datatable', organizationID);
        this.initActions(organizationID);
        return this.datatable;
    }
    init(el) {
        return $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            ajax: {
                url: '?do=getGateways',
                type: 'POST',
                data: {
                    organizationID: new URLSearchParams(window.location.search).get('organizationID')
                }
            },
            language: {
                emptyTable: "No data found"
            },
            drawCallback: function (settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=gateways-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: 'uuid',
                    title: 'Gateway',
                    sortable: true,
                    className: 'min-w-150px',
                    render: function (data, type, row) {
                        return '<div class="d-flex align-items-center">' +
                            '       <div class="symbol symbol-40px me-3">' +
                            '           <img src="/vendor/external/country-flags/png100px/' + row['iso2'] + '.png" class="w-auto" alt="flag">' +
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column" id="' + row['uuid'] + '">' +
                            '           <span class="fw-bold text-decoration-underline-ga primary text-primary mb-1 fs-6 ' + (row['edit'] ? 'edit-gateway' : '') + '" data-gateway-name="' + row['name'] + '">' + row['name'] + '</span>' +
                            '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">' + row['iso2'].toUpperCase() + ' - ' + row["city"] + '</span>' +
                            '       </div>' +
                            '   </div>';
                    }
                },
                {
                    data: 'ip',
                    title: 'IP / Hostname',
                    className: 'text-center',
                    sortable: false,
                    render: function (data, type, row) {
                        return '<div class="text-primary fw-bolder">' + row['ip'] + '</div><div class="text-primary">' + row['dns'] + '</div>';
                    }
                },
                {
                    data: 'status',
                    title: 'Status',
                    className: 'text-center',
                    sortable: false,
                    render: function (data, type, row) {
                        if (row['zabbixStatus'] !== 0) {
                            switch (row['status']) {
                                case 'up':
                                    return '<b class="text-success">UP</b>';
                                case 'down':
                                    return '<b class="text-danger">DOWN</b>';
                                default:
                                    return '<b class="text-warning" >' + row["status"] + '</b>';
                            }
                        } else {
                            return '<b class="text-warning" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="This node is currently experiencing network issues. We are investigating this instability.">Warning</b>';
                        }
                    }
                },
                {
                    data: null,
                    title: 'Actions',
                    width: 100,
                    sortable: false,
                    overflow: 'visible',
                    className: 'overflow-visible',
                    render: function (data, type, row) {
                        if (row['edit']) {
                            let html = '<div class="datatable-action min-w-2" id="' + row['uuid'] + '" ip="' + row['ip'] + '">';
                            if (row['delete']) {
                                html += '<div class="btn btn-icon btn-bg-light btn-sm ' + (!row['usedBranches'] ? 'btn-active-color-primary delete-gateway cursor-pointer' : 'cursor-not-allowed') + '" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="' + (!row['usedBranches'] ? 'Delete' : '<div class=\'text-center\'>Branch ' + row['usedBranches'] + ' is connected to this Gateway. Remove this connection first.</div>') + '">' +
                                    '                   <span class="svg-icon svg-icon-3">' +
                                    '                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '                           <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                    '                           <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                    '                           <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                    '                       </svg>' +
                                    '                   </span>' +
                                    '               </div>';
                            }
                            return html + '</div>';
                        }
                        return '';
                    }
                }
            ],
        }).on('init.dt', function () {

        });
    }
    initActions(organizationID){
        let thisClass = this;
        $(document).on('click', '.delete-gateway', function(e) {
            let gatewayID = $(this).parent()[0].id;
            let gatewayName = $(this).closest('tr').find('[data-gateway-name]').attr('data-gateway-name');
            Swal.fire({
                html: `<span class="text-center text-primary">`+(gatewayName !== undefined ? `<b>`+gatewayName+`</b>` : `Gateway`)+` will be completely deleted and you will lose your dedicated IP address. This action cannot be undone.</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                customClass: {
                    confirmButton: "btn btn-danger",
                    cancelButton: 'btn btn-light-primary'
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/gateways/?do=removeGateway&organizationID='+organizationID+'&gatewayID='+gatewayID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'deleted') {
                        toastr.success('Gateway has been deleted.');
                        thisClass.datatable.ajax.reload(null, false);
                        window.location.reload();
                    } else {
                        toastr.error('You\'ve exceeded the limit for deleting Gateways. Try again in a few days or contact support.');
                    }
                }
            });
        });
    }
}
window.GatewaysOrderDatatable = GatewaysOrderDatatable;